var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_5822_40069)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5822_40069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 17,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5822_40069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9 37.3L31.3 31.7C30.8 32.1 30.225 32.4167 29.575 32.65C28.925 32.8833 28.2333 33 27.5 33C25.6833 33 24.1458 32.3708 22.8875 31.1125C21.6292 29.8542 21 28.3167 21 26.5C21 24.6833 21.6292 23.1458 22.8875 21.8875C24.1458 20.6292 25.6833 20 27.5 20C29.3167 20 30.8542 20.6292 32.1125 21.8875C33.3708 23.1458 34 24.6833 34 26.5C34 27.2333 33.8833 27.925 33.65 28.575C33.4167 29.225 33.1 29.8 32.7 30.3L38.325 35.925C38.5083 36.1083 38.5958 36.3375 38.5875 36.6125C38.5792 36.8875 38.4833 37.1167 38.3 37.3C38.1167 37.4833 37.8833 37.575 37.6 37.575C37.3167 37.575 37.0833 37.4833 36.9 37.3ZM27.5 31C28.75 31 29.8125 30.5625 30.6875 29.6875C31.5625 28.8125 32 27.75 32 26.5C32 25.25 31.5625 24.1875 30.6875 23.3125C29.8125 22.4375 28.75 22 27.5 22C26.25 22 25.1875 22.4375 24.3125 23.3125C23.4375 24.1875 23 25.25 23 26.5C23 27.75 23.4375 28.8125 24.3125 29.6875C25.1875 30.5625 26.25 31 27.5 31ZM27.5 29.5C27.2167 29.5 26.9792 29.4042 26.7875 29.2125C26.5958 29.0208 26.5 28.7833 26.5 28.5V27.5H25.475C25.1917 27.5 24.9583 27.4042 24.775 27.2125C24.5917 27.0208 24.5 26.7833 24.5 26.5C24.5 26.2167 24.5958 25.9792 24.7875 25.7875C24.9792 25.5958 25.2167 25.5 25.5 25.5H26.5V24.475C26.5 24.1917 26.5958 23.9583 26.7875 23.775C26.9792 23.5917 27.2167 23.5 27.5 23.5C27.7833 23.5 28.0208 23.5958 28.2125 23.7875C28.4042 23.9792 28.5 24.2167 28.5 24.5V25.5H29.525C29.8083 25.5 30.0417 25.5958 30.225 25.7875C30.4083 25.9792 30.5 26.2167 30.5 26.5C30.5 26.7833 30.4042 27.0208 30.2125 27.2125C30.0208 27.4042 29.7833 27.5 29.5 27.5H28.5V28.525C28.5 28.8083 28.4042 29.0417 28.2125 29.225C28.0208 29.4083 27.7833 29.5 27.5 29.5Z",
    fill: "rgba(0, 0, 0, 0.87)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5822_40069",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5822_40069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5822_40069",
    result: "effect2_dropShadow_5822_40069"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5822_40069",
    result: "effect3_dropShadow_5822_40069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5822_40069",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.06d2113b62f92b6c69d5d5b6652b2a6c.svg";
export { ForwardRef as ReactComponent };